const gridSelector = '.blocks-gallery-grid';
const columnClassPrefix = 'columns-';

function justifyGrid() {
  $(gridSelector).each(function() {
    const $gridEl = $(this);
    const columns = gridColumns($gridEl);
    if (columns > 1) {
      const columnAdjustments = new Array(columns).fill(0);
      const columnHeights = new Array(columns).fill(0);
      const $childrenEls = $gridEl.children();
      $childrenEls.css('position', 'relative');
      $childrenEls.each(function(i) {
        const $childEl = $(this);
        const $imgEl = $childEl.find('img');
        $imgEl.on('load', justifyGrid);
        const column = i % columns;
        $childEl.css('top', `${0 - columnAdjustments[column]}px`);
        if ($childrenEls.length > i + columns) {
          columnAdjustments[column] += $childEl.outerHeight() - $imgEl.outerHeight();
        }
        columnHeights[column] += $childEl.outerHeight(true) - $childEl.outerHeight() + $imgEl.outerHeight();
      })
      $gridEl.css('height', `${Math.max(...columnHeights)}px`);
    } else {
      $gridEl.css('height', 'auto');
    }
  });
}

function gridColumns($gridEl) {
  let columns = 1;
  $.each($gridEl.parent().get(0).className.split(' '), function(i, className) {
    if (className.indexOf(columnClassPrefix) === 0) {
      columns = parseInt(className.substr(columnClassPrefix.length), 0);
    }
  });
  return columns;
}

export default function() {
  justifyGrid();
  $(window).on('resize', justifyGrid);
  $(window).on('fpgmedia:post_loaded', justifyGrid);
}



// WEBPACK FOOTER //
// ./scripts/components/masonry-grid.js